import { render, staticRenderFns } from "./printing_Why.vue?vue&type=template&id=a2b152a0&scoped=true"
import script from "./printing_Why.vue?vue&type=script&lang=js"
export * from "./printing_Why.vue?vue&type=script&lang=js"
import style0 from "./printing_Why.vue?vue&type=style&index=0&id=a2b152a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b152a0",
  null
  
)

export default component.exports